<template>
  <ConfigurationSection
    :configuration="configuration"
    :precedence="precedence"
    section-type="tenant"
    :section-title="computedTitle"
    :section-description="'Final configuration layer - these values override all preset configurations above.'"
    section-icon="building-office"
    :section-badge="{
      text: 'tenant',
      variant: 'info'
    }"
    :tenant-id="tenantId"
    :tenant-display-name="tenantDisplayName"
    :is-highlighted="isHighlighted"
    @section-interaction="notifyInteraction"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ConfigurationSection from '@/components/organisms/ConfigurationSection.vue'

interface Props {
  tenantId?: string
  tenantDisplayName?: string
  configuration: Record<string, any> | null
  precedence?: number
  isHighlighted?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'node-interaction': []
}>()

// Computed title that shows tenant name clearly
const computedTitle = computed(() => {
  if (props.tenantDisplayName) {
    return `${props.tenantDisplayName}`
  }
  if (props.tenantId) {
    return `${props.tenantId}`
  }
  return 'Tenant'
})

const notifyInteraction = () => {
  emit('node-interaction')
}
</script>
